module.exports = __webpack_public_path__ + "img/search.dfa7e7d7.svg";